import { useEffect, useState } from "react";
import { adminListWaitlist } from "@/lib/api";
import { ListChecks, Download } from "lucide-react";

const fmt = (d) => { try { return new Date(d).toLocaleDateString(); } catch { return d; } };

export default function AdminWaitlist() {
  const [items, setItems] = useState(null);

  useEffect(() => { adminListWaitlist().then(setItems).catch(() => setItems([])); }, []);

  const exportCsv = () => {
    const rows = [["email", "name", "interests", "source", "joined"]].concat(
      (items || []).map((i) => [i.email, i.name, (i.interests || []).join(" | "), i.source, i.created_at])
    );
    const csv = rows.map((r) => r.map((c) => `"${String(c || "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "waitlist.csv";
    a.click();
  };

  return (
    <div className="mx-auto max-w-4xl" data-testid="admin-waitlist">
      <div className="mb-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <ListChecks className="h-6 w-6 text-saffron" />
          <h1 className="font-serif-latin text-3xl text-ink">Waitlist</h1>
        </div>
        {items?.length > 0 && (
          <button onClick={exportCsv} data-testid="waitlist-export" className="inline-flex items-center gap-1.5 border border-line px-3 py-1.5 text-sm text-ink-2 transition-colors hover:border-saffron hover:text-saffron">
            <Download className="h-4 w-4" /> Export CSV
          </button>
        )}
      </div>
      <p className="mb-6 max-w-2xl text-sm text-ink-3">People who registered interest in upcoming features such as Panchangam Premium.</p>

      {items === null ? (
        <p className="py-20 text-center text-ink-3">…</p>
      ) : items.length === 0 ? (
        <p className="py-20 text-center text-ink-3">No sign-ups yet.</p>
      ) : (
        <div className="overflow-x-auto border border-line bg-surface">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-line text-left text-xs uppercase tracking-wide text-ink-3">
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Interests</th>
                <th className="px-4 py-3">Source</th>
                <th className="px-4 py-3">Joined</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} data-testid={`waitlist-${i.id}`} className="border-b border-line last:border-0">
                  <td className="px-4 py-3 text-ink">{i.email}</td>
                  <td className="px-4 py-3 text-ink-2">{i.name || "—"}</td>
                  <td className="px-4 py-3 text-ink-2">{(i.interests || []).join(", ") || "—"}</td>
                  <td className="px-4 py-3 text-ink-3">{i.source}</td>
                  <td className="px-4 py-3 text-ink-3">{fmt(i.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
